/* eslint-disable max-len */
import React from 'react';
import {IconProps} from './types';
export const EarlyAccessIconSVG: React.FC<IconProps> = ({ isWithBorder }) => {
  return (
    <svg width="42" height="42">
      <g fill="none" fillRule="evenodd">
        {isWithBorder && (
          <path
            d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
            fill="#CCCBCB"
            fillRule="nonzero"
          />
        )}
        <path d="M5 5h31v31H5z" />
        <path
          d="M21 8C13.85 8 8 13.85 8 21s5.85 13 13 13 13-5.85 13-13S28.15 8 21 8Zm0 23.4c-5.733 0-10.4-4.667-10.4-10.4 0-5.733 4.667-10.4 10.4-10.4 5.733 0 10.4 4.667 10.4 10.4 0 5.733-4.667 10.4-10.4 10.4Zm-.325-16.9a.975.975 0 0 0-.975.975v6.266a1 1 0 0 0 .476.852l5.439 3.347a.992.992 0 0 0 1.365-.325.981.981 0 0 0-.33-1.355l-4.514-2.709a1 1 0 0 1-.486-.857v-5.219a.975.975 0 0 0-.975-.975Z"
          fill="#327C8C"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
